import { useState } from 'react'

const KEY = 'recall_cookie_consent'
type Consent = 'accepted' | 'declined' | null

export function useCookieConsent() {
  const [consent, setConsent] = useState<Consent>(
    () => (localStorage.getItem(KEY) as Consent) ?? null
  )

  const accept = () => {
    localStorage.setItem(KEY, 'accepted')
    setConsent('accepted')
  }

  const decline = () => {
    localStorage.setItem(KEY, 'declined')
    setConsent('declined')
  }

  return { consent, accept, decline }
}
